<script lang="ts">
	import { _ } from 'svelte-i18n';

	import Loader from '$lib/components/Loader/Loader.svelte';

	import MobileColumSelector from '$lib/components/headerBar/performance/tables/MobileColumnSelector.svelte';

	import { getHubStores } from '$lib/stores/hubStores';

	import './style/table.css';
	import type { UserMetrics } from '$lib/api/restApi';

	export let postId: string;
	export let userId: string;

	export let published: boolean;

	let loading = true;

	const { hub, restApi } = getHubStores();

	let data: UserMetrics[];

	type sorting = 'VIEW' | 'POST_COMMENT' | 'POST_LIKE';

	const fetchHubUser = async (limit: number) => {
		if (lastLine) {
			return;
		}
		try {
			loading = true;
			let resp = await restApi.fetchPerformancePageUser(
				$hub.id,
				postId,
				userId,
				limit,
				undefined,
				!published
			);
			if (resp.status === 200 && resp.data) {
				data = resp.data;
				loading = false;
				if (data.length < limit) {
					lastLine = true;
				}
			}
		} catch (err) {
			console.error(err);
			loading = false;
		}
	};

	let currentOrder: sorting = 'VIEW';

	let lastLine = false;

	let limit = 20;

	let tableElement: HTMLElement;
	const loadOnScroll = () => {
		if (tableElement.scrollTop >= tableElement.scrollHeight - 500) {
			limit = limit + 100;
		}
	};

	// eslint-disable-next-line @typescript-eslint/no-floating-promises
	$: fetchHubUser(limit);

	const getEvent = (post: UserMetrics, event_type: sorting): string => {
		const find = post.events.find((e) => e.event_type === event_type);
		if (find == undefined) {
			return '';
		}
		return new Date(find.ts).toLocaleString($hub.locale, { hour: 'numeric', hour12: true });
	};
</script>

{#if data && data.length > 0}
	<div on:scroll={loadOnScroll} bind:this={tableElement} class="performance-table">
		<table>
			<thead>
				<tr class="desktop-table">
					<th>{$_('performance.modal.headers.sessions')}</th>
					<th>{$_('performance.modal.headers.views')}</th>
					<th>{$_('performance.modal.headers.contributions')}</th>
					<th>{$_('performance.modal.headers.likes')}</th>
				</tr>
				<tr class="mobile-table">
					<th>{`${$_('performance.modal.headers.posts')} (${data.length})`}</th>
					{#if currentOrder === 'VIEW'}
						<th>{$_('performance.modal.headers.views')}</th>
					{:else if currentOrder == 'POST_COMMENT'}
						<th>{$_('performance.modal.headers.contributions')}</th>
					{:else if currentOrder == 'POST_LIKE'}
						<th>{$_('performance.modal.headers.likes')}</th>
					{/if}
				</tr>
			</thead>
			<tbody class="desktop-table">
				{#each data as post}
					<tr>
						<td
							>{new Date(post.start).toLocaleString($hub.locale, {
								year: 'numeric',
								month: 'long',
								day: 'numeric',
							})}</td>
						{#if post.events}
							<td>{getEvent(post, 'VIEW')}</td>
							<td>{getEvent(post, 'POST_COMMENT')}</td>
							<td>{getEvent(post, 'POST_LIKE')}</td>
						{:else}
							<td /><td /><td />
						{/if}
					</tr>
				{/each}
				<Loader {loading} />
			</tbody>
			<tbody class="mobile-table">
				{#each data as post}
					<tr>
						<td
							>{new Date(post.start).toLocaleString($hub.locale, {
								year: 'numeric',
								month: 'long',
								day: 'numeric',
							})}</td>
						{#if post.events}
							{#if currentOrder === 'VIEW'}
								<td>{getEvent(post, 'VIEW')}</td>
							{:else if currentOrder == 'POST_COMMENT'}
								<td>{getEvent(post, 'POST_COMMENT')}</td>
							{:else if currentOrder == 'POST_LIKE'}
								<td>{getEvent(post, 'POST_LIKE')}</td>
							{/if}
						{:else}
							<td /><td /><td />
						{/if}
					</tr>
				{/each}
				<Loader {loading} />
			</tbody>
		</table>
	</div>
{:else}
	<div class="performance-table">
		<table>
			<thead>
				<tr class="desktop-table">
					<th>{`${$_('performance.modal.headers.users')} (0)`}</th>
					<th>{`${$_('performance.modal.headers.views')} (0)`}</th>
					<th>
						{`${$_('performance.modal.headers.contributions')} (0)`}
					</th>
					<th>
						{`${$_('performance.modal.headers.likes')} (0)`}
					</th>
				</tr>
				<tr class="mobile-table">
					<th>{`${$_('performance.modal.headers.users')} (0)`}</th>
					{#if currentOrder === 'VIEW'}
						<th>
							{`${$_('performance.modal.headers.views')} (0)`}
						</th>
					{:else if currentOrder == 'POST_COMMENT'}
						<th>
							{`${$_('performance.modal.headers.contributions')} (0)`}
						</th>
					{:else if currentOrder == 'POST_LIKE'}
						<th>
							{`${$_('performance.modal.headers.likes')} (0)`}
						</th>
					{/if}
				</tr>
			</thead>
		</table>
	</div>
	<h3 class="empty">{$_('performance.user.metrics.empty')}</h3>
{/if}
<div class="mobile-table">
	<div class="mobile-column-selector">
		<MobileColumSelector
			onChange={(column) => {
				if (column === 0) {
					currentOrder = 'VIEW';
				} else if (column === 1) {
					currentOrder = 'POST_COMMENT';
				} else if (column === 2) {
					currentOrder = 'POST_LIKE';
				}
			}} />
	</div>
</div>
